<template>
  <div class="select-container">
    <h2 v-html="title" />
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        @click.prevent="() => change(item)"
      >
        <div>
          <div class="boxIcon_box">
            <!-- <div class="boxIcon_center" /> -->
            <img
              v-if="item.answerCode === answerCode"
              class="boxIcon"
              src="../assets/images/circle-green.png"
            >
            <img
              v-else
              class="boxIcon"
              src="../assets/images/circle-gray.png"
            >
          </div>
          <span :class="{ selected: item.answerCode === answerCode }">{{ item.answerContent }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'RadioGroup',
  // eslint-disable-next-line vue/require-prop-types
  props: ['title', 'id', 'list', 'onChange', 'answerCode'],
  computed: {
  },
  methods: {
    change (item) {
      const { answerCode } = item
      if (answerCode === this.answerCode) { // 未改变
        return
      }
      this.onChange(answerCode, this.id)
    }
  }
}
</script>

<style scoped lang="less">
  .select-container {
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.18);
    &:only-child {
      border-bottom: 0;
    }
    &:last-child {
      margin-bottom: 0;
      border-bottom: 0;
    }
    h2 {
      padding: 40px 0;
      font-weight: 400;
      font-size: 28px;
      color: #1D272D;
    }
    ul {
      display: flex;
      justify-content: left;
      flex-wrap: wrap;
      li {
        margin-right: 27px;
        margin-bottom: 34px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        &.two {
          width: 299px;
          margin-right: 27px;
        }
        & > div {
          display: flex;
          align-items: center;
          min-width: 174px;
          font-size: 50px;
        }
        span {
          flex: 1;
          word-break: break-word;
          display: inline-block;
          font-size: 28px;
          font-weight: 400;
          color: #86949E;
          margin-left: 10px;
           &.selected {
            color: #45D4A8;
          }
        }
        .boxIcon_box{
          height: 28px;
          width: 28px;
          margin-top: 3px;
          position: relative;
        }
        .boxIcon {
          display: block;
          width: 100%;
          height: 100%;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
